// Import React and button styles
import React from "react";
import "../../../css/buttons/Button.css";
import "../../../css/buttons/SecondaryButton.css";

// SecondaryButton component renders a styled secondary button with optional text or children
const SecondaryButton = ({ children, onClick, disabled, text }) => {
  return (
    // The button uses conditional classes for disabled state
    <button
      className={`btn btn-secondary${disabled ? " btn-disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {/* Render the text prop if provided, otherwise render children */}
      <div className="nav"> {text || children} </div>
    </button>
  );
};

// Export the SecondaryButton component for use in other parts of the app
export default SecondaryButton;
